/* Verolae · Testimonials — carousel + mobile "read more" toggle.
   Reproduces the source section's inline script (mbv2_testimonials_8):
   Swiper (loop, watchSlidesProgress, arrows, bullet pagination, 1.2 / 2 / 3 slides per view)
   and the small/big text toggle. Uses the globally loaded Swiper 11 (window.Swiper);
   scoped per section instance via data-section-id; console noise removed. */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.verolae-testimonials[data-section-id]';
  var instances = {};

  function bindReadMore(root) {
    root.querySelectorAll('.testimonials-slide-text').forEach(function (el) {
      var btn = el.querySelector('.testimonials-slide-text-btn');
      var small = el.querySelector('.testimonials-slide-text-small');
      var big = el.querySelector('.testimonials-slide-text-big');
      if (!btn || !small || !big || btn.getAttribute('data-bound')) return;
      btn.setAttribute('data-bound', '1');
      var moreLabel = btn.getAttribute('data-more') || '';
      var lessLabel = btn.getAttribute('data-less') || '';
      btn.addEventListener('click', function () {
        var open = !btn.classList.contains('active');
        btn.classList.toggle('active', open);
        small.classList.toggle('active', open);
        big.classList.toggle('active', open);
        btn.textContent = open ? lessLabel : moreLabel;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function init(root) {
    var id = root.getAttribute('data-section-id');
    if (!id || instances[id] || !window.Swiper) return;
    var slider = root.querySelector('.testimonials-slider');
    if (!slider) return;
    var slideCount = slider.querySelectorAll('.swiper-slide').length;

    slider.classList.remove('preview');

    instances[id] = new window.Swiper(slider, {
      speed: 300,
      // Source: loop: true. Swiper 11 disables loop (with a warning) when there are fewer than
      // slidesPerView + 1 slides, so only loop when the editor has enough review blocks.
      loop: slideCount > 3,
      watchSlidesProgress: true,
      navigation: {
        nextEl: root.querySelector('.testimonials-btn-next'),
        prevEl: root.querySelector('.testimonials-btn-prev')
      },
      pagination: {
        el: root.querySelector('.testimonials-pagination'),
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        320: { centeredSlides: true, spaceBetween: 20, slidesPerView: 1.2 },
        768: { centeredSlides: false, spaceBetween: 20, slidesPerView: 2 },
        1024: { centeredSlides: true, spaceBetween: 20, slidesPerView: 3 }
      }
    });

    bindReadMore(root);
  }

  function destroy(id) {
    if (instances[id]) {
      instances[id].destroy(true, true);
      delete instances[id];
    }
  }

  function whenSwiperReady(callback, tries) {
    if (window.Swiper) { callback(); return; }
    tries = tries || 0;
    if (tries > 100) return; // give up after ~10 s (Swiper is loaded globally in theme.liquid)
    setTimeout(function () { whenSwiperReady(callback, tries + 1); }, 100);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  function boot() { whenSwiperReady(initAll); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector(ROOT_SELECTOR);
      if (root) whenSwiperReady(function () { init(root); });
    });
    document.addEventListener('shopify:section:unload', function (event) {
      destroy(event.detail.sectionId);
    });
    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest(ROOT_SELECTOR);
      if (!root) return;
      var swiper = instances[root.getAttribute('data-section-id')];
      var index = parseInt(event.target.getAttribute('data-slide-index'), 10);
      if (!swiper || isNaN(index)) return;
      if (swiper.params.loop) { swiper.slideToLoop(index); } else { swiper.slideTo(index); }
    });
  }
})();
